import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { UserProfile } from "../models/user-profile.model";

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private readonly apiUrl = `${environment.apiUrl}/admin/users`;

    constructor(private http: HttpClient) {}

    /**
     * Returns the user associated with the userId, or null if absent.
     */
    getUser(userId: string): Observable<UserProfile | null> {
        return this.http
            .get<{ user: UserProfile }>(`${this.apiUrl}/${userId}`)
            .pipe(map(({ user }) => user ?? null));
    }

    /**
     * Sets or clears the reset requirement. The Hub owns the accompanying
     * timestamp — it's what the token gate compares Firebase's passwordUpdatedAt
     * against, so a client-supplied value could backdate its way past the check.
     */
    requirePasswordReset(
        userId: string,
        requiresPasswordReset: boolean,
    ): Observable<UserProfile | null> {
        return this.http
            .put<{ user: UserProfile }>(`${this.apiUrl}/${userId}`, { requiresPasswordReset })
            .pipe(map(({ user }) => user ?? null));
    }


}
